import parts from './parts';



dn.$store.registerModule('top', {
  namespaced: true,

  modules: {
    parts,
  },
});

dn.$store.dispatch('top/parts/load');



// WEBPACK FOOTER //
// ./src/js/top/store/index.js